import { render, staticRenderFns } from "./LandDetail.vue?vue&type=template&id=302bfd5d&scoped=true&"
import script from "./LandDetail.vue?vue&type=script&lang=js&"
export * from "./LandDetail.vue?vue&type=script&lang=js&"
import style0 from "./LandDetail.vue?vue&type=style&index=0&id=302bfd5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302bfd5d",
  null
  
)

export default component.exports